import { createSlotsContext } from "@grandvisionhq/slots";
const [StoreAddressFormSlotsProvider, useStoreAddressFormSlotsContext] = createSlotsContext({
  displayName: "StoreAddressFormSlotsContext"
});
export {
  StoreAddressFormSlotsProvider,
  useStoreAddressFormSlotsContext
};
//# sourceMappingURL=StoreAddressFormSlotsContext.js.map
